import React from 'react';

interface SectionSelectProps {
  label: string;
  value: string | null | undefined;
  options: string[];
  locked?: boolean;
  onChange: (v: string | null) => void;
}

export const SectionSelect = ({ label, value, options, locked, onChange }: SectionSelectProps) => (
  <div>
    <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">
      {label}
      {locked && <span className="ml-1 text-gray-400 text-[10px]">🔒 fixed</span>}
    </label>
    <select
      className="w-full border border-gray-300 dark:border-gray-600 rounded px-2 py-1.5 text-sm bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-blue-500 focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed"
      value={value ?? ''}
      disabled={locked}
      onChange={(e) => onChange(e.target.value || null)}
    >
      <option value="">— None —</option>
      {options.map((o) => (
        <option key={o} value={o}>{o.replace(/_/g, ' ')}</option>
      ))}
      {value && !options.includes(value) && (
        <option value={value}>{value} (custom)</option>
      )}
    </select>
  </div>
);
